import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { Graph_QL, useFeedCurves } from "../../../Services";
import { SelectFieldOption_Values } from "../../../Definitions";

export const useFeedcurveOptions = (includeUndefinedOption?: UndefinedOptions, feedCurveId?: number) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getFeedCurves, data: feedCurvesState } = useFeedCurves(connection);

  useEffect(() => {
    getFeedCurves({ fetchAmount: 500, ifFeedCurveBaseInfoOnly: false });
  }, []);

  const feedcurveOptions: SelectFieldOption_Values[] = useMemo(() => {
    if (feedCurvesState && feedCurvesState[domain]) {
      const feedCurves = feedCurvesState[domain].data
        .filter((feedCurve) => feedCurve.info?.deleted !== true)
        .map(feedCurve => ({
          label: feedCurve.name,
          id: feedCurve.feedCurveId,
        }));

      if (includeUndefinedOption === UndefinedOptions.undefined)
        return [{ label: "no feed curve", id: null }, ...feedCurves];
      if (includeUndefinedOption === UndefinedOptions.nan)
        return [{ label: "no feed curve", id: NaN }, ...feedCurves];

      return feedCurves;
    }

    return [];
  }, [feedCurvesState, domain, includeUndefinedOption]);



  const milestoneOptionsFromFeedcurve: SelectFieldOption_Values[] | undefined = useMemo(() => {
    if (feedCurvesState && feedCurvesState[domain]) {
      const feedCurve = feedCurvesState[domain].data.find(
        f => f.feedCurveId === feedCurveId
      );
      return feedCurve?.milestones?.map(milestone => ({
        label: milestone.name,
        id: milestone.feedCurveMilestoneId,
        // milestoneKey: milestone.milestoneId,
        index: milestone.milestoneIndex
      })).sort((a, b) => a.index - b.index) ?? [];
    }
  }, [domain, feedCurveId, feedCurvesState])

  return {feedcurveOptions, milestoneOptionsFromFeedcurve};
};